// COMPACTO_GERAL_2910 (GROK2 29/10): painel compacto em todas as abas/modais.
// Só exibição: esconde textos de ajuda (viram tooltip ⓘ), stats viram linha fina,
// filtros longos recolhem atrás de um botão "Filtros". Nada é apagado.
// Desligar: private/COMPACTO_GERAL_2910_OFF
import { useEffect } from 'react';
import './compacto2910.css';

const HINT_RE = /muted|hint|desc|intro|note|help|subtitle|lead|caption/i;
const STAT_RE = /metric|kpi|stat-card|statcard|stat-tile|summary-card/i;
const SKIP_SEL = 'table,[class*=chat],[class*=message],[class*=msg],[class*=bubble],[class*=conversation],.office-mobile-navigation,.office-sidebar,[data-cg-keep],[contenteditable]';

function anchorFor(p) {
  let s = p.previousElementSibling;
  while (s && (s.hasAttribute('data-cg-hint') || !s.innerText || !s.innerText.trim())) s = s.previousElementSibling;
  if (s && s.innerText.trim().length < 80) return s;
  const par = p.parentElement;
  if (!par) return null;
  const h = par.querySelector('h1,h2,h3,h4,label,strong,[class*=title],[class*=label]');
  return h && h !== p && !h.contains(p) ? h : null;
}

function run() {
  const roots = [document.querySelector('main.office-shell-main'), ...document.querySelectorAll('[role=dialog],.office-dialog')].filter(Boolean);
  roots.forEach((root) => {
    // 1) textos de ajuda -> tooltip
    root.querySelectorAll('p,small,span.office-metric-hint,div.office-metric-hint').forEach((p) => {
      if (p.hasAttribute('data-cg-hint') || p.hasAttribute('data-cg-seen')) return;
      p.setAttribute('data-cg-seen', '1');
      if (p.closest(SKIP_SEL)) return;
      const cls = String(p.className || '') + ' ' + String(p.parentElement?.className || '');
      const t = (p.innerText || '').trim();
      if (t.length < 40 || !HINT_RE.test(cls)) return;
      if (p.querySelector('input,button,select,a,textarea')) return;
      const a = anchorFor(p);
      p.setAttribute('data-cg-hint', '1');
      if (a && !a.contains(p)) {
        a.setAttribute('title', ((a.getAttribute('title') || '') + ' ' + t).trim());
        a.setAttribute('data-cg-info', '1');
      }
    });
    // badge do vínculo da revenda
    root.querySelectorAll('.rv-hierarchy__hint:not([title])').forEach((h) => h.setAttribute('title', h.innerText.trim()));
    if (root.matches('[role=dialog],.office-dialog')) {
      root.querySelectorAll('.office-dialog-desc,[id$=-description]').forEach((d) => {
        if (d.hasAttribute('data-cg-hint')) return;
        const t = d.innerText.trim(); if (!t) return;
        d.setAttribute('data-cg-hint', '1');
        const ti = root.querySelector('h2,[id$=-title]'); if (ti) { ti.setAttribute('title', t); ti.setAttribute('data-cg-info', '1'); }
      });
      return;
    }
    // 2) grade de cartões de número -> linha fina
    root.querySelectorAll('div,section,ul').forEach((g) => {
      if (g.hasAttribute('data-cg-stats') || g.children.length < 2 || g.closest(SKIP_SEL) || g.parentElement?.closest('[data-cg-stats]')) return;
      const kids = [...g.children];
      const hits = kids.filter((k) => STAT_RE.test(String(k.className || ''))).length;
      if (hits >= 2 && hits >= kids.length - 1) g.setAttribute('data-cg-stats', '1');
    });
    // 3) filtros longos -> botão Filtros (só o menor bloco de filtro, nunca a página)
    const isF = (f) => {
      if (f.closest('[data-cg-filtros],details,.cg-filtros-btn')) return false;
      if (f.querySelector('table,[data-cg-filtros],.mo-pills-2810,[data-cg-stats],[class*=empty],[class*=list],[class*=panel]')) return false;
      if (f.querySelectorAll('input,select,[role=combobox],button[aria-haspopup]').length < 4) return false;
      const cls = String(f.className || '');
      const btns = [...f.querySelectorAll('button')].map((b) => (b.innerText || '').trim().toLowerCase());
      return /filter|filtro/i.test(cls) || btns.some((b) => b === 'aplicar' || b === 'aplicar filtros');
    };
    const cands = [...root.querySelectorAll('section,form,div')].filter((f) => !f.hasAttribute('data-cg-fseen') && isF(f));
    // fica com o MAIOR candidato que ainda é só filtro (contém os campos e o Aplicar)
    cands.filter((f) => !cands.some((o) => o !== f && o.contains(f))).forEach((f) => {
      f.setAttribute('data-cg-fseen', '1');
      f.setAttribute('data-cg-filtros', 'fechado');
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'cg-filtros-btn'; b.setAttribute('data-cg-filtros-btn', '1');
      b.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 5h18l-7 8v6l-4 2v-8z"/></svg><span>Filtros</span>';
      b.onclick = () => { const o = f.getAttribute('data-cg-filtros') === 'aberto'; f.setAttribute('data-cg-filtros', o ? 'fechado' : 'aberto'); b.classList.toggle('is-on', !o); };
      f.parentElement.insertBefore(b, f);
    });
    // 4) Atualizar/Recarregar enormes -> botão pequeno
    root.querySelectorAll('button').forEach((b) => {
      if (b.hasAttribute('data-cg-ref')) return;
      const t = (b.innerText || '').trim();
      if (/^(atualizar|recarregar)$/i.test(t) && b.querySelector('svg')) { b.setAttribute('data-cg-ref', '1'); b.setAttribute('title', t); }
    });
    // 5) título repetido: h1 da seção igual à pílula/sub-aba ativa
    const on = [...document.querySelectorAll('.mo-pill-2810.is-on,.mo-pill-2810-s.is-on')].map((a) => a.innerText.trim().toLowerCase());
    root.querySelectorAll('.office-section-header h1,.office-section-header h2').forEach((h) => {
      if (on.includes(h.innerText.trim().toLowerCase())) h.setAttribute('data-cg-dup', '1'); else h.removeAttribute('data-cg-dup');
    });
    // 6) cartões de lista no celular: 2-3 linhas + "Mais"
    root.querySelectorAll('.om-table tbody tr').forEach((tr) => {
      const id = tr.querySelector(':scope>.om-cell--identity');
      if (!id || tr.hasAttribute('data-cg-card')) return;
      tr.setAttribute('data-cg-card', '1');
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'cg-mais'; b.textContent = 'Mais ▾';
      b.onclick = (ev) => { ev.stopPropagation(); const o = tr.hasAttribute('data-cg-open'); if (o) tr.removeAttribute('data-cg-open'); else tr.setAttribute('data-cg-open', '1'); b.textContent = o ? 'Mais ▾' : 'Menos ▴'; };
      (id.querySelector('.rv-user-meta') || id.querySelector('.om-cell-value') || id).appendChild(b);
    });
    // 7) Contatos (CRM) e afins: Etapas/Perfil atrás de um botão Filtros na mesma linha
    root.querySelectorAll('.leads-toolbar').forEach((tb) => {
      if (tb.hasAttribute('data-cg-lf')) return;
      const ds = [...tb.querySelectorAll(':scope>details.console-filters')];
      if (!ds.length) return;
      tb.setAttribute('data-cg-lf', 'fechado');
      ds.forEach((d) => { d.open = true; });
      const b = document.createElement('button');
      b.type = 'button'; b.className = 'cg-filtros-btn'; b.title = 'Etapas e perfil';
      b.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 5h18l-7 8v6l-4 2v-8z"/></svg><span>Filtros</span>';
      b.onclick = () => { const o = tb.getAttribute('data-cg-lf') === 'aberto'; tb.setAttribute('data-cg-lf', o ? 'fechado' : 'aberto'); b.classList.toggle('is-on', !o); };
      tb.appendChild(b);
    });
  });
}

export function useCompacto2910(on) {
  useEffect(() => {
    const b = document.body;
    if (!on) { b.removeAttribute('data-compacto-geral-2910'); return undefined; }
    b.setAttribute('data-compacto-geral-2910', '1');
    let raf = 0;
    const sched = () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; try { run(); } catch (e) { /* só exibição */ } }); };
    const mo = new MutationObserver(sched);
    mo.observe(document.body, { childList: true, subtree: true });
    sched();
    return () => { mo.disconnect(); if (raf) cancelAnimationFrame(raf); b.removeAttribute('data-compacto-geral-2910'); };
  }, [on]);
}

// LIMPA_TOPO_2910 (switch private/LIMPA_TOPO_2910_OFF): só marca o body; CSS em compacto2910.css
export function useLimpaTopo2910(on) {
  useEffect(() => {
    const b = document.body;
    if (on) b.setAttribute('data-limpa-topo-2910', '1'); else b.removeAttribute('data-limpa-topo-2910');
    if (!on) return () => b.removeAttribute('data-limpa-topo-2910');
    // LIMPA_TOPO_2910 (e/m): marca o título interno repetido (igual ao título do topo ou à sub-aba ativa) e a página atual
    const norm = (t) => String(t || '').replace(/\s+/g, ' ').trim().toLowerCase();
    let raf = 0;
    const run = () => {
      raf = 0;
      const p = window.location.pathname;
      b.setAttribute('data-lt-pg', p.startsWith('/gestor-xui/clients') ? 'clients' : p.startsWith('/gestor-xui/tests') ? 'tests' : 'x');
      const top = new Set();
      document.querySelectorAll('.office-unified-header h1, .office-mobile-header h1, [role=tab][aria-selected=true], [role=tab][data-state=active], .mo-pills-2810 [aria-current], .mo-pills-2810 .is-active, .mo-pills-2810 [data-state=active], .team-main-tabs [data-state=active], nav [aria-current=page]')
        .forEach((el) => { const t = norm(el.textContent); if (t) top.add(t); });
      document.querySelectorAll('main .office-section-header').forEach((h) => {
        const t = norm(h.querySelector('h1,h2')?.textContent);
        if (t && top.has(t)) h.setAttribute('data-lt-dup', '1'); else h.removeAttribute('data-lt-dup');
      });
    };
    const mo = new MutationObserver(() => { if (!raf) raf = requestAnimationFrame(run); });
    mo.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-selected', 'data-state', 'aria-current'] });
    run();
    return () => { mo.disconnect(); if (raf) cancelAnimationFrame(raf); b.removeAttribute('data-limpa-topo-2910'); b.removeAttribute('data-lt-pg'); };
  }, [on]);
}
